import React from "react";

export default function TvSettings({ config }) {
  const rows = [
    ["Enabled", config?.enabled ? "Yes" : "No"],
    ["Mode", config?.mode || "VIDEO_ONLY"],
    ["Orientation", config?.orientation || "LANDSCAPE"],
    ["Transition", config?.transition || "FADE"],
    ["Slide Duration", `${config?.slideDuration ?? 8}s`],
    ["Fit Mode", config?.fitMode || "CROP"],
    ["Video Mute", config?.videoMute ? "Muted" : "Audio Enabled"],
    ["Keep Screen Awake", config?.keepScreenAwake ? "Enabled" : "Disabled"],
    ["Published Version", String(config?.publishedVersion ?? 0)],
  ];

  return (
    <section className="tv-display-panel">
      <div className="tv-display-panel-head">
        <div>
          <h2 className="tv-display-panel-title">Display Settings</h2>
          <p className="tv-display-panel-copy">
            This section reflects the shared config document that admin and TV clients will both read.
          </p>
        </div>
      </div>

      <div className="tv-display-settings-grid">
        {rows.map(([label, value]) => (
          <div key={label} className="tv-display-setting-item">
            <div className="tv-display-setting-label">{label}</div>
            <div className="tv-display-setting-value">{value}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
